export class UUID {
    private static S4(): string {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }

    // then to call it, plus stitch in '4' in the third group
    public static generate() {
        return (
            UUID.S4() +
            UUID.S4() + '-' +
            UUID.S4() + '-4' +
            UUID.S4().substr(0, 3) + '-' +
            UUID.S4() + '-' +
            UUID.S4() +
            UUID.S4() +
            UUID.S4()).toLowerCase();
    }
}